import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// Valores por defecto
const DEFAULT_FILTER = 'featured';
const DEFAULT_PAGE = 1;

// Utilidad para parsear int seguro
const parsePage = (value) => {
  const n = parseInt(value, 10);
  return isNaN(n) || n < 1 ? DEFAULT_PAGE : n;
};

// Utilidad para construir params sin undefined/null
const buildParams = (paramsObj) => {
  const params = {};
  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value;
    }
  });
  return params;
};

// Hook principal
export default function useBoatFiltersFromUrl() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Leer filtros desde la URL
  const filter = searchParams.get('filter') || DEFAULT_FILTER;
  const size = searchParams.get('size') || null;
  const category = searchParams.get('category') || null;
  const page = parsePage(searchParams.get('page'));

  // Log de lectura de filtros y página
  console.log('[useBoatFiltersFromUrl] Read from URL:', { filter, size, category, page });

  // Actualizar filtro de precio (resetea otros y la página)
  const setFilter = useCallback((newFilter) => {
    console.log('[useBoatFiltersFromUrl] setFilter:', newFilter);
    setSearchParams(buildParams({ filter: newFilter, page: '1' }));
  }, [setSearchParams]);

  // Actualizar filtro de tamaño (resetea otros y la página)
  const setSize = useCallback((newSize) => {
    console.log('[useBoatFiltersFromUrl] setSize:', newSize);
    setSearchParams(buildParams({ size: newSize, page: '1' }));
  }, [setSearchParams]);

  // Actualizar filtro de categoría (resetea otros y la página)
  const setCategory = useCallback((newCategory) => {
    console.log('[useBoatFiltersFromUrl] setCategory:', newCategory);
    setSearchParams(buildParams({ category: newCategory, page: '1' }));
  }, [setSearchParams]);

  // Actualizar página (mantiene los filtros actuales)
  const setPage = useCallback((newPage) => {
    const params = Object.fromEntries([...searchParams]);
    params.page = String(newPage);
    console.log('[useBoatFiltersFromUrl] setPage:', newPage, 'params:', params);
    setSearchParams(buildParams(params));
  }, [searchParams, setSearchParams]);

  // Limpiar todos los filtros (vuelve a featured y página 1)
  const clearFilters = useCallback(() => {
    console.log('[useBoatFiltersFromUrl] clearFilters');
    setSearchParams(buildParams({ filter: DEFAULT_FILTER, page: '1' }));
  }, [setSearchParams]);

  return {
    filter,
    size,
    category,
    page,
    setFilter,
    setSize,
    setCategory,
    setPage,
    clearFilters,
  };
} 